import { useNavigate } from "react-router-dom";
import { t } from "ttag";

import { ScreenLayout } from "@/app/components/layouts";
import { CallToAction } from "@/app/components/legacy-components";
import { ROUTES } from "@/app/router";
import {
  PastConsultations,
  UpcomingConsultations,
} from "@/features/consultations/sections";
import { useCurrentMedicationRequests } from "@/features/my-meds/hooks";
import { GLP1_CATEGORIES } from "@/features/products/models";
import { usePageTitle } from "@/shared/hooks";
import { CalendarMinimalisticIcon, Header, PopoverTooltip } from "@/shared/ui";

export const Consultations = () => {
  usePageTitle(t`Consultations`);

  const navigate = useNavigate();

  const { data: currentMedicationRequests } = useCurrentMedicationRequests();

  const hasPendingMedicationRequest = currentMedicationRequests?.some(
    (request) => GLP1_CATEGORIES.includes(request.product.category.slug),
  );

  return (
    <ScreenLayout>
      <Header.Root>
        <Header.Content className="flex-row items-center justify-between gap-4">
          <Header.Title>{t`Consultations`}</Header.Title>

          <PopoverTooltip.Root>
            <PopoverTooltip.Trigger asChild>
              <div>
                <Header.Button
                  disabled={hasPendingMedicationRequest}
                  onClick={() => navigate(ROUTES.CONSULTATIONS.PURPOSE)}
                  className="w-fit"
                >
                  <CalendarMinimalisticIcon className="size-4" />
                  <span>{t`Book now`}</span>
                </Header.Button>
              </div>
            </PopoverTooltip.Trigger>

            {hasPendingMedicationRequest && (
              <PopoverTooltip.Content className="max-w-full text-center">
                {t`Booking is unavailable while your request is in progress.`}
              </PopoverTooltip.Content>
            )}
          </PopoverTooltip.Root>
        </Header.Content>
      </Header.Root>

      <UpcomingConsultations />

      <CallToAction
        title={t`Want to review your refill medication requests?`}
        buttonText={t`Go to My Meds`}
        onClick={() => navigate(ROUTES.MY_MEDS)}
      />

      <PastConsultations />
    </ScreenLayout>
  );
};
